import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { MailingListService } from '@mailer/services/MailingListService';
import i18n from '@app/plugins/i18n';

class MailingModalService extends ModalService {
  constructor() {
    super(MailingListService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('mailer.mailing.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }
}

const instance = new MailingModalService();
export { instance as MailingModalService };
